
import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useQuery } from '@apollo/react-hooks';
import ls from 'local-storage';
import { useEffectOnce } from 'react-use';

import { Loader } from '@squirrellearningltd/go-teacher-components';
import { getAppTokenName } from '@squirrellearningltd/go-shared-utils';

import { AuthContext } from '../../../services/user/AuthProvider';
import { LOGGED_IN } from '../services/graphql';
import Ssl from './Ssl';
import { Router, Location } from '@reach/router';


import Dashboard from '../../Dashboard';
import Schools from '../../Schools';
import Trials from '../../Trials';
import SchoolHome from '../../School/scenes/SchoolHome';
import AddSchool from '../../School/scenes/AddSchool';
import EditSchool from '../../School/scenes/EditSchool';

import InvoicesHome from '../../Invoices/scenes/InvoicesHome';
import InvoicesDashboard from '../../Invoices/scenes/InvoicesDashboard';

import ViewInvoice from '../../Invoices/scenes/ViewInvoice';
import OrdersHome from '../../Orders/scenes/OrdersHome';
import ViewOrder from '../../Orders/scenes/ViewOrder';

import PacksHome from '../../Packs/scenes/PacksHome';
import EditPack from '../../Pack/scenes/EditPack';
import AddPack from '../../Pack/scenes/AddPack';
import Book from '../../Book';
import Books from '../../Books';
import FindParent from '../../FindParent';
import WriteToRaise from '../../WriteToRaise';
import WtrListSchools from '../../WriteToRaise/WtrListSchools';
import Users from '../../Users';

import SetPassword from '../../Login/scenes/SetPassword';
import ResetSent from '../../Login/scenes/ResetSent';
import Login from '../../Login';
import FranchiseLogin from '../../Login/FranchiseLogin';
import LoggedInRouter from './LoggedInRouter';
import Header from '../../../components/Header';
import styles from '../Home.module.scss';
import { APP_NAME } from '../../../services/constants';
import RouteCapture from './RouteCapture';
import WritingBees from '../../WritingBees';
import ManageBee from '../../WritingBees/ManageBee';
import InvoicesBySource from '../../Invoices/scenes/InvoicesBySource';
import WondeSchools from '../../Schools/WondeSchools';
import Notifications from '../../Notifications/index';
import Notification from '../../Notification/index';
import Subcategories from '../../Subcategories/index';
import AddSubcategory from '../../Subcategory/scenes/AddSubcategory';
import SubcategoryHome from '../../Subcategory/scenes/SubcategoryHome';
import DataDashboard from '../../DataDashboard';
import BoomerItems from '../../BoomerItems';
import BoomerCategoryItems from '../../BoomerItems/BoomerCategoryItems';
import AddBoomerItem from '../../BoomerItems/AddBoomerItem';
import AddSpecialStore from '../../BoomerItems/AddSpecialStore';
import SpecialStores from '../../BoomerItems/SpecialStores';
import RewardCards from '../../RewardCards/RewardCards';
import Franchises from '../../Franchises';
import Franchise from '../../Franchises/components/Franchise';
import FranchiseFinance from '../../Franchises/components/FranchiseFinance';
import FranchiseSchools from '../../Franchises/components/FranchiseSchools';
import AddFranchise from '../../Franchises/components/AddFranchise';
import FranchisePortal from '../../Franchises/components/FranchisePortal';
import FranchiseRevenue from '../../Franchises/components/FranchiseRevenue';
import AddFranchiseSchool from '../../Franchises/components/AddFranchiseSchool';
import FranchiseSchool from '../../Franchises/components/FranchiseSchool';
import EditFranchiseSchool from '../../Franchises/components/EditFranchiseSchool';
import FranchiseSchoolAdmins from '../../Franchises/components/FranchiseSchoolAdmins';
import FranchiseAdmins from '../../Franchises/components/FranchiseAdmins';
import FranchiseAdministrators from '../../Franchises/components/FranchiseAdministrators';
import AcceptFranchiseInvite from '../../Login/AcceptFranchiseInvite';

const RouterAuthQuery = () => {
    const { data, error, loading } = useQuery(LOGGED_IN);
    const auth = useContext(AuthContext);

    const [ready, setReady] = useState(false);


    useEffect(() => {
        if (ls(getAppTokenName(APP_NAME)) && !auth.currentUser && ls('go_educator_user') && ls('go_educator_user') !== 'undefined') {
            auth.setCurrentUser(JSON.parse(ls('go_educator_user')));
        }
    }, [auth]);

    useEffectOnce(() => {
        if (ls(getAppTokenName(APP_NAME)) && !auth.currentUser && ls('go_educator_user') && ls('go_educator_user') !== 'undefined') {
            auth.setCurrentUser(JSON.parse(ls('go_educator_user')));
        }
        setReady(true);
    });

    const renderContent = () => {
        if (error) {
            return <p>{error.message}</p>
        }

        if (loading) {
            return <Loader />
        }

        if (data && ready) {
            return (
                <Router>
                    <RouteCapture path='/'>
                        <AcceptFranchiseInvite path='/franchise/:franchiseId/accept_invite/:token' />
                        {auth.currentUser ? (
                            <LoggedInRouter path='/' default>
                                {auth.currentUser.isSuperadmin === true && <Dashboard path='/' default />}
                                <FranchisePortal path='/franchise-portal/:franchiseId' />
                                <FranchiseRevenue path='/franchise-portal/:franchiseId/revenue' />
                                <FranchiseAdministrators path='/franchise-portal/:franchiseId/admins' />
                                <FranchiseSchools path='/franchise-portal/:franchiseId/schools' portal={true} />
                                <AddFranchiseSchool path='/franchise-portal/:franchiseId/schools/new' portal={true} />
                                <FranchiseSchool path='/franchise-portal/:franchiseId/schools/:schoolId' portal={true} />
                                <FranchiseSchoolAdmins path='/franchise-portal/:franchiseId/schools/:schoolId/admins' portal={true} />
                                <EditFranchiseSchool path='/franchise-portal/:franchiseId/schools/:schoolId/edit' portal={true} />

                                <SchoolHome path='/school/:schoolId' />
                                <EditSchool path='/school/:schoolId/edit' />
                                <AddSchool path='/school/new/india' india={true} />
                                <ManageBee path='/writingBees/' />

                                {auth.currentUser.countryAdmin !== 'IND' && (
                                    <>
                                        <AddSchool path='/school/new' />
                                        <PacksHome path='/packs' />
                                        <Book path='/book/:bookTemplateCategoryId/:bookId' />
                                        <Books path='/books/' />
                                        <AddPack path='/pack/new' />
                                        <EditPack path='/pack/:bookTemplateCategoryId' />
                                        <Schools path='/schools' />
                                        <WondeSchools path='/schools/wonde' />

                                        <WriteToRaise path='/writeToRaise' />
                                        <WtrListSchools path='/wtrListSchools' />
                                        <Users path='/users' />
                                        <Trials path='/trials' />
                                        <WritingBees path='/writingBees' />
                                        <InvoicesHome path='/invoicesOld' />
                                        <ViewInvoice path='/invoices/:invoiceId' />

                                        <InvoicesDashboard path='/invoices' />
                                        <InvoicesBySource path='/invoicesBySource/:source' />

                                        <OrdersHome path='/orders' />
                                        <ViewOrder path='/orders/:orderId' />
                                        <FindParent path='/findParent' />
                                        <Notifications path='/notifications' />
                                        <Notification path='/notification/:id' />
                                        <Subcategories path='/pack/:packId/subcategories' />
                                        <AddSubcategory path='/subcategory/new/:packId' />
                                        <SubcategoryHome path='/subcategory/:subcategoryId' />

                                        <DataDashboard path='/dataDashboard/*' />
                                        <BoomerItems path='/boomerItems' />
                                        <SpecialStores path='/boomerItems/specialStore' />
                                        <AddSpecialStore path='/boomerItems/specialStore/new' />
                                        <SpecialStores path='/boomerItems/specialStore/:openingId/edit' />
                                        <BoomerCategoryItems path='/boomerItems/:categoryKey' />
                                        <AddBoomerItem path='/boomerItems/:categoryKey/new' />
                                        <BoomerCategoryItems path='/boomerItems/:categoryKey/:itemId/edit' />
                                        <RewardCards path='/rewardPacks/*' />
                                        <Franchises path='/franchises' />
                                        <AddFranchise path='/franchises/new' />
                                        <Franchise path='/franchises/:franchiseId' />
                                        <FranchiseFinance path='/franchises/:franchiseId/finance' />
                                        <FranchiseAdmins path='/franchises/:franchiseId/admins' />
                                        <FranchiseSchools path='/franchises/:franchiseId/schools' />
                                        <AddFranchiseSchool path='/franchises/:franchiseId/schools/new' />
                                        <FranchiseSchool path='/franchises/:franchiseId/schools/:schoolId' />
                                        <FranchiseSchoolAdmins path='/franchises/:franchiseId/schools/:schoolId/admins' />
                                        <EditFranchiseSchool path='/franchises/:franchiseId/schools/:schoolId/edit' />
                                    </>
                                )}
                               
                            </LoggedInRouter>
                        ) :
                            <Fragment>
                                <Login path='/' default />
                                <FranchiseLogin path='/franchiselogin' />
                                <SetPassword path='/setpassword/:token/*' />
                                <SetPassword path='/invite/:token' />
                                <ResetSent path='/reset_sent' />
                            </Fragment>
                        }
                    </RouteCapture>
                </Router>
            )
        }
    }

    return (
        <Fragment>
            <Ssl />
            <Location>
                {({ location }) => auth.currentUser && location.pathname.startsWith('/franchise-portal/') ? null : <Header user={auth.currentUser} />}
            </Location>
            <div className={styles.appContainer} >
                {renderContent()}
            </div>
        </Fragment>
    );
}

export default RouterAuthQuery;
